module.exports = __webpack_public_path__ + "img/ícone1.38aefd7f.png";